import React, { PropsWithChildren, HTMLAttributes } from 'react'

const MultilineContainer = ({ 
  children,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div style={{ whiteSpace: 'pre-line' }} {...props}>
      {children}
    </div>
  )
}

export default MultilineContainer
